import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import React, { useState } from "react";
import { useParams } from "react-router";
import "../../components/ExploreContainer.css";
import {
  Box,
  Divider,
  InputLabel,
  MenuItem,
  TextField,
  FormControl,
  Autocomplete,
  Container,
  Paper,
  Button,
  FormLabel,Radio,RadioGroup,
  FormControlLabel,
  
  CircularProgress,
  Alert,
  AlertTitle,
  Typography,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import axios from "axios";
import { baseUrl, config, requestID } from "../../common/utils";
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"

const schema = yup.object({
  amount: yup.string().required(" Please Enter an amount"),
}).required();

const WithdrawalRequest = () => {


  



  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const { name } = useParams<{ name: string }>();
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState<any>(null);
  const [amount, setAmount] = useState<string>("");
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");
  const [selection, setSelection] = useState<string>("self");
  const [status, setStatus] = useState({ loading: false, error: false });


  const requestWithdrawal = async () => {
    try {
      setStatus({ loading: true, error: false });
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("amount", amount);
      formData.append("user_id", results?.user_id);

      const response = await axios.post(
        baseUrl() + "withdrawals/withdrawalRequestStaff",
        formData,
        config
      );
      console.log(response);

      if (response.data.status === true) {
      
        setAlertMsg(response.data.message);
        setSearchTerm('')
        setAmount('')
        onShowAlert();
        setStatus({ loading: false, error: false });
        reset()
      } else {
        setAlertMsg(response.data.message);
        onShowAlert();
        setStatus({ loading: false, error: true });
      }
    } catch (error) {
      setStatus({ loading: false, error: true });
    }
  };


  const handleSearch = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("searchTerm", searchTerm);

      const response = await axios.post(
        baseUrl()+ `users/searchUser`,
        formData,
        config
      );

      const { data } = response.data;
      console.log(data);
      const fetchedResults = data;
      setResults(fetchedResults);
      setStatus({ loading: false, error: false });
    } catch (error) {
      console.error(error);
      setStatus({ loading: false, error: true });
    } finally {
      setStatus({ loading: false, error: false });
    }
  };

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };
  const top100Films = [
    { label: "The Shawshank Redemption", year: 1994 },
    { label: "The Godfather", year: 1972 },
  ];
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">{name}</IonTitle>
          </IonToolbar>
        </IonHeader>


        <Container component="main" maxWidth="md" sx={{ mt: 8, mb: 2 }}>
          <Paper elevation={3} sx={{ padding: 3 }}>
            {showAlert && (
              <Alert severity={status.error ? "error" : "success"}>
                <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
                {alertMsg?.toUpperCase()}
              </Alert>
            )}
            <Typography variant="h5" component="h1" gutterBottom>
              Search User
            </Typography>
            <form onSubmit={handleSearch}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Search by Email or Phone"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                required
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ mt: 2 }}
              >
                {status.loading ? <CircularProgress /> : "Submit"}
              </Button>
            </form>
            {results ? (
              <>
                <List sx={{ mt: 3 }}>
                  <ListItem>
                    <ListItemText
                      primary={`Name: ${results.firstName} ${results.middleName} ${results.lastName}`}
                      secondary={`Phone: ${results.phone}`}
                    />
                  </ListItem>
                </List>
                <Box
          sx={{
            paddingTop: "20px",
            "& > :not(style)": { m: 1 },
          }}
        >
          <h4>Withdrawal Details</h4>
          <Divider orientation="horizontal" flexItem />
        </Box>
        {/* {showAlert && (
          <Alert severity={status.error ? "error" : "success"}>
            <AlertTitle>{status.error ? "Error " : "Success"}</AlertTitle>
            {alertMsg?.toUpperCase()}
          </Alert>
        )} */}
         <Box sx={{ mt: 3 }}>
                  <Typography variant="h6" component="h2" gutterBottom>
                    Additional Information
                  </Typography>
          

                  <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Amount
                    </Typography>
                    <TextField
                variant="outlined"
                margin="normal"
                error={!!errors.amount}          
                helperText={errors.amount?.message}
                fullWidth
                label="Amount"
                {...register('amount')}
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                required
              />
                  </Box>
                  <Button
                    type="button"
                    variant="contained"
                    color="secondary"
                    security="primary"
                    size="large"
                    fullWidth
                    sx={{ mt: 2 }}
                    onClick={handleSubmit(requestWithdrawal)}
                  >
                    {status.loading ? <CircularProgress /> : "Submit Request"}
                  </Button>
                </Box>
       
              </>
            ) : (
              <List sx={{ mt: 3 }}>
                <ListItem>
                  <ListItemText>No User found</ListItemText>
                </ListItem>
              </List>
            )}
          </Paper>
        </Container>

      
       
       
      </IonContent>
    </IonPage>
  );
};

export default WithdrawalRequest;
